/**
 * SB-10242: the CEU Credits line used to print the fixed "CEU Credit Hours:"
 * (translated) whatever the organizer called the field. A Library rename
 * ("CEU Credits" → "CME Credits") or the embed's own field label now shows
 * as typed; the field's standard name keeps the translated default wording.
 *
 * The API resolves the name (embed label > Library rename > field name), so
 * the widgets only pick it up from the grouped fields.
 *
 * @param {Array<Object|undefined>} fieldsByIdList one or more maps keyed by internal_name, highest precedence first
 * @param {(key: string) => string} t
 * @returns {string}
 */
const STANDARD_NAME = 'ceu credits';

const ceuCreditsLabel = (fieldsByIdList, t) => {
  for (const fieldsById of fieldsByIdList || []) {
    const raw = fieldsById?.ceu_credits?.name;
    if (typeof raw !== 'string') continue;
    const name = raw.trim().replace(/:\s*$/, '').trim();
    if (!name) continue;
    if (name.toLowerCase() === STANDARD_NAME) break;
    return `${name}:`;
  }
  return t('ceu_credit_hours');
};

export default ceuCreditsLabel;
